module.exports = __webpack_public_path__ + "1791188489487/fonts/line-awesome.4d42f5f.ttf";